import copyJson from '../../../demo/fixtures/w3/copy.json'
import upliftJson from '../../../demo/fixtures/w3/uplift.json'
import type { Optimization, PlanReason } from '../../../demo/types'
import { Icon, Skeleton, Spinner } from '../../../ui'
import { AutopilotLog, type AnalysisTargets } from '../AutopilotLog'
import styles from '../AutopilotSection.module.css'

interface CopyFixture { logTitle: string; running: string; noFinding: string; noData: string }
interface UpliftFixture { footnote: string }
const copy = copyJson as unknown as CopyFixture
const upliftCopy = upliftJson as unknown as UpliftFixture

interface LogPaneProps {
  running: boolean
  notice: PlanReason | null
  optimizations: Optimization[]
  visibleIds: Set<string> | null
  animateIds: Set<string>
  expanded: boolean
  audienceEdited: boolean
  targets: AnalysisTargets
  onExpandedChange: (value: boolean) => void
  onUndo: (id: string) => void
  onGo: (target: string) => void
}

export function LogPane(props: LogPaneProps) {
  const { running, notice, optimizations, visibleIds, animateIds, expanded, audienceEdited, targets, onExpandedChange, onUndo, onGo } = props
  return <div data-scope="ap-log">
    {running ? <div data-context="autopilot-running"><div className={styles.runningLine}><Spinner /><span>{copy.running}</span></div><Skeleton lineWidth="60" /><Skeleton className={styles.skeletonMiddle} lineWidth="80" /><Skeleton className={styles.skeletonLast} lineWidth="40" /></div> : <>
      {notice === 'no_finding' ? <div className={styles.notice}><span><Icon name="check-circle" size={16} strokeWidth={2} /></span><p>{copy.noFinding}</p></div> : null}
      {notice === 'no_data' ? <p className={styles.noData}>{copy.noData}</p> : null}
      {optimizations.length ? <><p className={styles.logTitle}>{copy.logTitle}</p><AutopilotLog items={optimizations} visibleIds={visibleIds} animateIds={animateIds} expanded={expanded} audienceEdited={audienceEdited} targets={targets} onExpandedChange={onExpandedChange} onUndo={onUndo} onGo={onGo} /></> : null}
      {optimizations.length ? <p className={styles.footnote}>{upliftCopy.footnote}</p> : null}
    </>}
  </div>
}
